import { type CheckboxProps } from '@radix-ui/react-checkbox';
import { forwardRef } from 'react';

import { Checkbox } from '../../../atoms';
import { useMultiselectItemContext } from '../MultiselectInput.context';

export const MultiselectItemCheckbox = forwardRef<
  HTMLButtonElement,
  Omit<CheckboxProps, 'id'> & { id: string }
>(({ className, id, ...props }, ref) => {
  const { selected } = useMultiselectItemContext();

  return (
    <Checkbox
      id={id}
      ref={ref}
      checked={selected}
      className={className}
      {...props}
    />
  );
});
